<template>
    <div style="min-height: 100vh; position: relative;">
      <div class="header">
        <a class="frontpage" href='/homepage'>首页</a>
        <span class="split"></span>
        <!-- <a class="history" href='/toolbox'>工具箱</a> -->
        <router-link to="/">工具箱</router-link>
        <span class="new-features" @click="openVideo">新功能介绍</span>
        <!-- <span class="split"></span>
        <a class="third" href='/history/multimedia/third'>第三方内容</a> -->
        <!-- <span class="exit" @click="console.log('logout')">退出</span> -->
      </div>
      <router-view />
      <div class="footer">Copyright &copy; 2019-2023 All Rights Reserved 新华通讯社通信技术局 版权所有</div>
      <Modal />
    </div>
    <!-- <router-view /> -->
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'App',
  components: {
    Modal,
  },
  methods: {
    openVideo() {
      this.$openVideo('https://v.xinhua-news.com/nspfeatures/recommend/poster.mp4', '新华全媒工具箱新功能介绍');
    }
  }
}
</script>


<style lang="scss">
@import '@/style.scss';

body {min-width: 1250px;}
a:link, a:visited, a:hover, a:active {text-decoration:none;}
.box{
  position:relative;
  width:100%; min-height:calc(100% - 50px);
  padding-top:50px;
}
</style>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 9999;
  width: 100%;
  height: 35px;
  padding: 5px;
  padding-left: 20px;
  top: 0;
  // border-bottom: 1px solid #eee;
  background-color: #f5f5f5;
  // text-align: right;
  line-height: 26px;
  font-size: 14px;
  color: #666;
  a {
    padding-left: 15px;
    cursor: pointer;
    color: #666;
    &:hover {
      color: #009ae0;
    }
    &:link, &:visited {
      color: #666;
    }
  }
  .split {
    margin-top: 6px;
    border-left: 1px solid #666;
    display: inline-block;
    height: 12px;
    margin-left: 10px;
  }
  .new-features {
    float: right;
    margin-right: 50px;
    color: #8ab8e7;
    font-size: 12px;
    cursor: pointer;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  text-align: center;
  line-height: 80px;
  font-size: 14px;
  background-color: #f5f5f5;
  color: #666;
  // background-color: #1e2635;
  // color: #525c70;
}
</style>
